import config from "../utils/config";
export const USER_STORAGE_KEY: string = "currentUser"
export const SELECTED_PROJECT_STORAGE_KEY: string = "selectedProjectUuid"
export const SAVED_SELECTED_MENU_STORAGE_KEY: string = "selectedMenuKey"
export const FULL_MONTHS = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];
export const SHORT_MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];
export const DAYS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];

export const ADMIN_VIEWS = {
    DASHBOARD_VIEW: 1,
    PROJECT_LIST_VIEW: 2,
    USER_LIST_VIEW: 3,
    NEW_PROJECT_VIEW: 4,
    NEW_USER_VIEW: 5,
    NEW_PARTICIPANT_VIEW: 6,
    NEW_CASH_IN_VIEW: 7,
    NEW_CASH_OUT_VIEW: 8,
    GROUP_LIST_VIEW: 9,
    NEW_GROUP_VIEW: 10,
    GROUP_DETAILS_VIEW: 11,
    EDIT_GROUP_VIEW: 12,
    TRANSACTION_HISTORY_VIEW: 13,
    MESSAGING_VIEW: 14
}

// Routes pour l'administration
export const ADMIN_ROUTES = {
    DASHBOARD: '/admin/dashboard',
    PROJECTS: '/admin/projects',
    USERS: '/admin/users',
    NEW_PROJECT: '/admin/projects/new',
    NEW_USER: '/admin/users/new',
    NEW_PARTICIPANT: '/admin/participants/new',
    NEW_CASH_IN: '/admin/cash-in/new',
    NEW_CASH_OUT: '/admin/cash-out/new',
    GROUPS: '/admin/groups',
    NEW_GROUP: '/admin/groups/new',
    GROUP_DETAILS: '/admin/groups/details',
    TRANSACTION_HISTORY: '/admin/transactions',
    MESSAGING: '/admin/messaging',
}

// Mapping entre les vues et les routes
export const VIEW_TO_ROUTE = {
    [ADMIN_VIEWS.DASHBOARD_VIEW]: ADMIN_ROUTES.DASHBOARD,
    [ADMIN_VIEWS.PROJECT_LIST_VIEW]: ADMIN_ROUTES.PROJECTS,
    [ADMIN_VIEWS.USER_LIST_VIEW]: ADMIN_ROUTES.USERS,
    [ADMIN_VIEWS.NEW_PROJECT_VIEW]: ADMIN_ROUTES.NEW_PROJECT,
    [ADMIN_VIEWS.NEW_USER_VIEW]: ADMIN_ROUTES.NEW_USER,
    [ADMIN_VIEWS.NEW_PARTICIPANT_VIEW]: ADMIN_ROUTES.NEW_PARTICIPANT,
    [ADMIN_VIEWS.NEW_CASH_IN_VIEW]: ADMIN_ROUTES.NEW_CASH_IN,
    [ADMIN_VIEWS.NEW_CASH_OUT_VIEW]: ADMIN_ROUTES.NEW_CASH_OUT,
    [ADMIN_VIEWS.GROUP_LIST_VIEW]: ADMIN_ROUTES.GROUPS,
    [ADMIN_VIEWS.NEW_GROUP_VIEW]: ADMIN_ROUTES.NEW_GROUP,
    [ADMIN_VIEWS.TRANSACTION_HISTORY_VIEW]: ADMIN_ROUTES.TRANSACTION_HISTORY,
    [ADMIN_VIEWS.MESSAGING_VIEW]: ADMIN_ROUTES.MESSAGING,
}

// Mapping inverse pour router vers vue
export const ROUTE_TO_VIEW = {
    [ADMIN_ROUTES.DASHBOARD]: ADMIN_VIEWS.DASHBOARD_VIEW,
    [ADMIN_ROUTES.PROJECTS]: ADMIN_VIEWS.PROJECT_LIST_VIEW,
    [ADMIN_ROUTES.USERS]: ADMIN_VIEWS.USER_LIST_VIEW,
    [ADMIN_ROUTES.NEW_PROJECT]: ADMIN_VIEWS.NEW_PROJECT_VIEW,
    [ADMIN_ROUTES.NEW_USER]: ADMIN_VIEWS.NEW_USER_VIEW,
    [ADMIN_ROUTES.NEW_PARTICIPANT]: ADMIN_VIEWS.NEW_PARTICIPANT_VIEW,
    [ADMIN_ROUTES.NEW_CASH_IN]: ADMIN_VIEWS.NEW_CASH_IN_VIEW,
    [ADMIN_ROUTES.NEW_CASH_OUT]: ADMIN_VIEWS.NEW_CASH_OUT_VIEW,
    [ADMIN_ROUTES.GROUPS]: ADMIN_VIEWS.GROUP_LIST_VIEW,
    [ADMIN_ROUTES.NEW_GROUP]: ADMIN_VIEWS.NEW_GROUP_VIEW,
    [ADMIN_ROUTES.TRANSACTION_HISTORY]: ADMIN_VIEWS.TRANSACTION_HISTORY_VIEW,
    [ADMIN_ROUTES.MESSAGING]: ADMIN_VIEWS.MESSAGING_VIEW,
}

export const ROLES = {
    ADMIN: "ADMIN",
    USER: "USER"
}

export const defaultUser = {
    uuid: "",
    email: "",
    role: "",
    projects: [],
    isActivated: true,
    firstname: "",
    defaultProject: undefined,
    lastname: "",
    tokens: {accessToken: "", refreshToken: ""}
}
export const defaultProject = {
    uuid: "",
    status: "",
    participants: 0,
    name: "",
    startDate: new Date(),
    endDate: new Date(),
    penaltyAmountPerDay: 0,
    penaltyPerDay: 0,
    dueDay: 0,
    currency: "EUR",
    activated: false,
    contribution: 0,
    withdrawalAmount: 0,
    withdrawalDay: 0,
    cashFundPercentage: 0,
    cashFundAmount: 0,
    share: 0,
    Users: [],
    Withdrawals: [],
    Penalties: [],
    TransactionIns: [],
    UserProjects: []
}
export const EMAIL_REG_EXPRESSION = /^[\w-+.]+@([\w-]+\.)+[\w-]{2,4}$/

/**
 * Validation mot de passe alignée avec le backend :
 * - Minimum 8 caractères
 * - Au moins 1 majuscule
 * - Au moins 1 minuscule
 * - Au moins 1 chiffre
 * - Au moins 1 caractère spécial parmi : !@#$%^&*(),.?":{}|<>
 */
export const PASSWORD_REG_EXPRESSION = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/
export const PASSWORD_REQUIREMENTS_MESSAGE = "Le mot de passe doit contenir au moins 8 caractères, une majuscule, une minuscule, un chiffre et un caractère spécial (!@#$%^&*...)"

/**
 * Validation nom/prénom alignée avec le backend :
 * - 2 à 50 caractères
 * - Lettres (minuscules/majuscules avec accents), espaces, trait d'union, apostrophes uniquement
 */
export const NAME_REG_EXPRESSION = /^[a-zA-ZÀ-ÿ\s-']+$/
export const NAME_MIN_LENGTH = 2
export const NAME_MAX_LENGTH = 50

/**
 * Validation groupes alignée avec le backend :
 * - Nom: 2 à 100 caractères
 * - Description: maximum 500 caractères
 * - Membres: maximum 100 UUIDs
 */
export const GROUP_NAME_MIN_LENGTH = 2
export const GROUP_NAME_MAX_LENGTH = 100
export const GROUP_DESCRIPTION_MAX_LENGTH = 500
export const GROUP_MAX_MEMBERS = 100

//****************************************** */
// export const VERSION = "local"
// export const BASE_URL: string = "http://localhost:300O"

// export const VERSION = "prod"
// export const VERSION = "local"
// export const BASE_URL: string = "https://ogu0lcsova.execute-api.eu-west-3.amazonaws.com"
// export const BASE_URL: string = "http://localhost:3001"
export const BASE_URL: string = config.api.baseUrl
export const VERSION: string = config.api.version

//********************************************************/

export const LOGIN_URL = `/auth/login`
export const ACTIVATE_URL = `/auth/activate`
export const LOGOUT_URL = `/auth/logout`
export const USER_DASHBOARD_URL = `/user/dashboard`
export const USER_PROJECT_DASHBOARD_URL = (projectUuid: string) => `/user/dashboard/project/${projectUuid}`
export const ADMIN_PROJECT_LIST_URL = `/admin/projects`
export const ADMIN_PROJECT_DASHBOARD_URL = (projectId: string) => `/admin/projects/${projectId}/dashboard`
export const ADMIN_PROJECT_MONTHLY_DATA_URL = (projectId: string, selectedMonth: string) => `/admin/projects/${projectId}/monthly-data`
export const ADMIN_PROJECT_PARTICIPANTS_URL = (projectId: string) => `/admin/projects/${projectId}/participants`
export const ADMIN_PROJECT_PAYMENT_REMINDERS_URL = (projectId: string) => `/admin/projects/${projectId}/reminders`
export const USER_SELF_INFO_URL = `${BASE_URL}/${VERSION}/user/project/default`
export const USER_PROJECT_URL = `${BASE_URL}/${VERSION}/user/project/me`
export const USER_LIST_URL = `${BASE_URL}/${VERSION}/admin/users`
export const REGISTRATION_URL = `${BASE_URL}/${VERSION}/auth/register`
export const NEW_PROJECT_URL = `${BASE_URL}/${VERSION}/admin/projects`
export const UPDATE_PROJECT_URL = (projectUuid: string) => `/admin/project/${projectUuid}`;
export const NEW_GROUP_URL = `${BASE_URL}/${VERSION}/admin/groups`
export const GROUP_LIST_URL = `${BASE_URL}/${VERSION}/admin/groups`
export const GROUP_USERS_URL = (groupId: string) => `${BASE_URL}/${VERSION}/admin/groups/${groupId}/users`
export const DELETE_GROUP_URL = (groupId: string) => `${BASE_URL}/${VERSION}/admin/groups/${groupId}`
export const CLEAR_GROUP_MEMBERS_URL = (groupId: string) => `${BASE_URL}/${VERSION}/admin/groups/${groupId}/members`
export const UPDATE_GROUP_URL = (groupId: string) => `${BASE_URL}/${VERSION}/admin/groups/${groupId}`
export const UPDATE_USER_URL = (userId: string) => `${BASE_URL}/${VERSION}/admin/users/${userId}`
export const REMOVE_PARTICIPANT_URL = (projectUuid: string, userUuid: string) => `${BASE_URL}/${VERSION}/admin/projects/${projectUuid}/participants/${userUuid}`;
export const NEW_CASH_IN_URL = (projectId: string, userId: string) => `/admin/projects/${projectId}/users/${userId}/transactions`
export const NEW_CASH_OUT_URL = `${BASE_URL}/${VERSION}/withdrawal`
export const NEW_PARTICIPANT_URL = (projectId: string) => `${BASE_URL}/${VERSION}/admin/projects/${projectId}/participants`;
export const ADMIN_TRANSACTIONS_URL = `/admin/transactions`;

// Messaging URLs
export const MESSAGES_CONVERSATIONS_URL = `/messages/conversations`;
export const MESSAGES_CONVERSATION_URL = (conversationId: string) => `/messages/conversations/${conversationId}`;
export const MESSAGES_SEND_URL = `/messages`;
export const MESSAGES_MARK_READ_URL = (messageId: string) => `/messages/${messageId}/read`;
export const MESSAGES_UNREAD_COUNT_URL = `/messages/unread-count`;
export const CURRENCY: { label: string, symbol: string }[] = [
    {label: "EUR", symbol: "€"},
    {label: "XOF", symbol: "CFA"},
]

// Project Lifecycle Management
export const PROJECT_STATUS = {
    DRAFT : 'DRAFT',
    STARTED : 'STARTED',
    ARCHIVED : 'ARCHIVED'
} as const;

export const PROJECT_STATUS_LABELS = {
    [PROJECT_STATUS.DRAFT]: 'Brouillon',
    [PROJECT_STATUS.STARTED]: 'Démarré',
    [PROJECT_STATUS.ARCHIVED]: 'Archivé'
} as const;

export const PROJECT_STATUS_COLORS = {
    [PROJECT_STATUS.DRAFT]: '#6b7280',        // Gris
    [PROJECT_STATUS.STARTED]: '#10b981',      // Vert
    [PROJECT_STATUS.ARCHIVED]: '#374151'      // Gris foncé
} as const;

// Descriptions pour chaque statut (aide utilisateur)
export const PROJECT_STATUS_DESCRIPTIONS = {
    [PROJECT_STATUS.DRAFT]: 'Le projet est en préparation. Les paramètres financiers peuvent être modifiés.',
    [PROJECT_STATUS.STARTED]: 'Le projet est actif. Les contributions et retraits sont en cours.',
    [PROJECT_STATUS.ARCHIVED]: 'Le projet est terminé ou suspendu. Aucune opération n\'est possible.'
} as const;

// Cycle libre : tous les changements de statut sont possibles
export const PROJECT_STATUS_TRANSITIONS = {
    [PROJECT_STATUS.DRAFT]: [PROJECT_STATUS.STARTED, PROJECT_STATUS.ARCHIVED],
    [PROJECT_STATUS.STARTED]: [PROJECT_STATUS.DRAFT, PROJECT_STATUS.ARCHIVED],
    [PROJECT_STATUS.ARCHIVED]: [PROJECT_STATUS.DRAFT, PROJECT_STATUS.STARTED]
} as const;

// Status that allow editing project values (seulement DRAFT et STARTED)
export const EDITABLE_PROJECT_STATUSES = [
    PROJECT_STATUS.DRAFT
] as const;
